module.exports = __webpack_public_path__ + "img/logo2.c699f92a.png";